import { render, staticRenderFns } from "./deliveryManage.vue?vue&type=template&id=e824738e&scoped=true&"
import script from "./deliveryManage.vue?vue&type=script&lang=js&"
export * from "./deliveryManage.vue?vue&type=script&lang=js&"
import style0 from "./deliveryManage.vue?vue&type=style&index=0&id=e824738e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e824738e",
  null
  
)

export default component.exports